import { render, staticRenderFns } from "./SliderCockpit.vue?vue&type=template&id=3a5db459&scoped=true"
import script from "./SliderCockpit.vue?vue&type=script&lang=js"
export * from "./SliderCockpit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5db459",
  null
  
)

export default component.exports